export const notifications = state => state.getIn(['notifications']);
